import styled from "styled-components";

export const VectorWrapperDiv = styled.div<{ $marginTop?: number; $marginBottom?: number }>`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  ${(props) => props.$marginTop && `margin-top: ${props.$marginTop}px;`}
  ${(props) => props.$marginBottom && `margin-bottom: ${props.$marginBottom}px;`}
`;
